<template>
    <vs-card class="w-11/12 shadow-lg">
        <action-bar class="action-bar">
            <template v-slot:left>
                <h2>Users</h2>
            </template>
        </action-bar>

        <vx-server-side-table
            striped
            class="px-4"
            ref="servertable"
            search
            :fetchData="$api.user.fetchUsers"
            :columns="columns"
            :filters.sync="customFilters"
        >
            <!-- @search="(text) => (filters.search = text)" -->
            <template v-slot:header-inner>
                <vs-button @click="startExport" color="primary" type="filled" class="self-end ml-5"
                    >Export as Excel
                </vs-button>
                <ExportExcel
                    v-if="readyForExport"
                    :sheets="sheets"
                    filename="users"
                    style="display: none"
                    @completed="completedExport"
                >
                </ExportExcel>
            </template>
            <!-- <template v-slot:interests="{ row }">
                <div v-if="!row.interests || row.interests.length == 0">No Interests</div>
                <div v-else>
                    <div v-for="(item, index) in row.interests" :key="'interests_' + index">
                        {{ getInterestDescription(item) }}
                    </div>
                </div>
            </template> -->
            <template v-slot:coupons="{ row }">
                <div v-if="!row.coupons || row.coupons.length == 0"></div>
                <div v-else>
                    <div v-for="(value, index) in row.coupons" :key="'coupons_' + index">
                        {{
                            'Code: ' +
                            value.couponCode +
                            ', Expiry: ' +
                            (value.expiryDate
                                ? new Date(value.expiryDate).toLocaleDateString()
                                : '')
                        }}
                    </div>
                </div>
            </template>
        </vx-server-side-table>
    </vs-card>
</template>

<script>
import CrmContent from '@/components/custom/CrmContent'
import ActionBar from '@/components/custom/ActionBar'
import ClientSideTable from '@/components/custom/ClientSideTable'
import ExportExcel from '@/components/excel/ExportExcelUpdated.vue'

export default {
    name: 'users',
    components: {
        CrmContent,
        ActionBar,
        ClientSideTable,
        ExportExcel
    },
    data() {
        return {
            filters: {
                search: ''
            },

            sheets: [
                {
                    sheetname: 'Users',
                    columns: [],
                    data: []
                }
            ],
            readyForExport: false
        }
    },
    computed: {
        columns() {
            return [
                { title: 'First Name', sort: 'firstName', value: 'firstName' },
                // { title: 'Last Name', sort: 'surname', value: 'surname' },
                { title: 'Email', sort: 'emailAddress', value: 'emailAddress' },
                {
                    title: 'Experience',
                    sort: 'meditationExperience',
                    value: 'meditationExperience'
                },
                {
                    title: 'Coupons',
                    value: 'coupons',
                    slotName: 'coupons'
                },

                {
                    title: 'Interests',
                    value: 'interests' /*, slotName: 'interests'*/,
                    format: this.getMultipleInterestDescription
                }
            ]
        },
        customFilters: {
            get() {
                return {
                    search: this.filters.search
                }
            },
            set(val) {
                this.filters.search = val.search
            }
        }
    },
    methods: {
        getMultipleCoupons(coupon) {
            if (coupon && coupon.length > 0) {
                return coupon.map((value) => value.CouponCode + ' ' + value.ExpiryDate).join(';')
            }
            return ''
        },
        async startExport() {
            this.loading = true
            let responseData = await this.$api.user.fetchUsersForExport({
                search: this.filters.search,
                pageSize: -1,
                pageNo: 0
            })

            this.sheets[0].sheetname = 'Users'
            this.sheets[0].columns = [
                { title: 'First Name', value: 'firstName' },
                { title: 'Last Name', value: 'surname' },
                { title: 'Email', value: 'emailAddress' },
                { title: 'Experience', value: 'meditationExperience' },
                {
                    title: 'Coupons',
                    value: 'coupons',
                    dataFormat: this.getMultipleCoupons
                },
                {
                    title: 'Interests',
                    value: 'interests',
                    dataFormat: this.getMultipleInterestDescription
                }
            ]

            if (responseData && responseData.length == 0) {
                this.notifyWarning('Warning', `No data to Export`, 5000)
                this.loading = false
                return
            }

            this.sheets[0].data = responseData
            this.readyForExport = true
        },
        completedExport() {
            this.loading = false
        }
    }
}
</script>

<style scoped>
h2 {
    color: #6a6e6e;
}
::v-deep .vs-card--content {
    min-height: 40vh;
}
</style>
